module.exports = __webpack_public_path__ + "img/kefu.862ad9e9.png";